export const SHOOTS_FETCH_REQUEST='shoots-fetch-request';
export const SHOOTS_FETCH_SUCCESS='shoots-fetch-success';
export const SHOOTS_FETCH_FAILURE='shoots-fetch-failure';